import { customTemplatesQuery } from 'components/domain/automation/customTemplates/customTemplatesQuery';
import FilterFormContextSearchField from 'components/filters/FilterFormContextSearchField';
import { SearchOption } from 'components/filters/FilterFormContextSearchField.styles';

const HeaderSearchField = () => {
  const searchHandler = async (query: string) => {
    const { queryFn } = customTemplatesQuery({
      name: query,
      pageIndex: 0,
      pageSize: 10,
      sorting: [{ id: 'name', desc: false }],
    });

    const { data } = await queryFn();

    return data;
  };

  return (
    <FilterFormContextSearchField
      colSmInput={12}
      containerClassName="search-field"
      labelKey={(option) => `${option.name ?? ''}`}
      name="customTemplateSearch"
      renderMenuItemChildren={(option) => (
        <SearchOption data-testid={`found-custom-template-${option.uid}`}>
          {option.name}
        </SearchOption>
      )}
      searchHandler={searchHandler}
    />
  );
};

export default HeaderSearchField;
